<template lang="html">
    <section class="section flex-block" :class="className" id="kontakt">
        <div class="container">
            <div class="columns is-centered">
                <div class="column has-text-centered">
                    <h2 class="title flex-footer-block__title">{{ data.title }}</h2>
                </div>
            </div>
            <div class="columns is-centered is-multiline">
                <div class="column is-6-tablet is-3-desktop" v-for="item in data.team">
                    <div class="card card--button-more-big" @click="goToUrl(item.link)">
                        <div class="card-image">
                            <figure class="image is-1by1">
                                <img :src="item.image.sizes.size318x398" :alt="item.title">
                            </figure>
                        </div>
                        <div class="card-content">
                            <h3 class="title">{{ item.title }}</h3>
                            <h4 class="subtitle">{{ item.subtitle }}</h4>
                            <a :href="item.email">{{ item.email }}</a>
                            <a class="button-more" :href="item.link">{{ $t("more") }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-centered">
                <div class="column">
                    <a href="https://ssw.solutions" target=_blank >
                        <img class="flex-footer-block__logo" src="@/../public/img/ssw-logo.png" alt="SSW Pragmatic Solutions Logo">
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    methods:{
        goToUrl(url){
            window.location = url
        }
    }
}
</script>

<style scoped lang="sass">
@import "@/styles/framework/variables.sass"
@import "@/styles/framework/extends.sass"
.flex-footer-block
    background-color: $grey2
    &__title
        margin-bottom: 2rem
        text-align: center
    &__logo
        display: block
        margin: 2rem auto
    .image
        img
            object-position: top
</style>
